import { render, staticRenderFns } from "./InventoryProductsBulkMoveImport.vue?vue&type=template&id=95e8724c&"
import script from "./InventoryProductsBulkMoveImport.vue?vue&type=script&lang=js&"
export * from "./InventoryProductsBulkMoveImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports